export default [
    {
        path: '/budget-planner',
        name: 'PageBudgetPlannerList',
        meta: { title: 'budgetPlanner.listTitle', roles: ['ADMIN'], permissions: ['budget_planner_view'] },
        component: () => import('@/pages/budget-planner'),
    },
]